import { RubrikConfigComponent } from '../rubrik-config.component';
import { AppCustomConfigService } from '../../../../core/services/app-custom-config.service';
import { RubrikVMService } from '../rubrik-v-m.service';
import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CapAlertService } from '../../../../core/extension/exceptions/cap-alert.service';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { RubrikConfigEntry } from '../../../../core/base-api';
import { RubrikComponent } from '../../../../shared/components/rubrik/rubrik.component';
import { NgClass, NgStyle, NgTemplateOutlet } from '@angular/common';
import { CdkDrag, CdkDropList } from '@angular/cdk/drag-drop';
import RubrikEnum = RubrikConfigEntry.RubrikEnum;

@Component({
  selector: 'cap-standardrecht-rubrik-config',
  templateUrl: '../rubrik-config.component.html',
  styleUrls: ['../rubrik-config.component.scss'],
  imports: [RubrikComponent, TranslatePipe, NgTemplateOutlet, CdkDropList, CdkDrag, NgClass, NgStyle]
})
export class StandardrechtRubrikConfigComponent extends RubrikConfigComponent {
  rubrikTitle = 'Standardrechtdetail';
  rubrikType = RubrikEnum.GB_DETAIL_STANDARDRECHT;

  constructor(
    protected rubrikService: AppCustomConfigService,
    protected rubrikVmService: RubrikVMService,
    protected modalService: NgbModal,
    protected capAlertService: CapAlertService,
    protected translateService: TranslateService,
    protected route: ActivatedRoute
  ) {
    super(rubrikService, rubrikVmService, modalService, capAlertService, translateService, route);
    keysToTranslate<string>(['configuration.reihenfolgeStandardrechtdetail', 'saveSuccessMessage']);
  }
}
